import { render, staticRenderFns } from "./AppointmentsDetails.vue?vue&type=template&id=5c72fba4&scoped=true"
import script from "./AppointmentsDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentsDetails.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsDetails.vue?vue&type=style&index=0&id=5c72fba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c72fba4",
  null
  
)

export default component.exports